import React from "react";

import type { BlockProps } from "@admin/components/Content/ContentBlocks";
import type { TextBlockValueModel } from "@admin/domain/content/models/ContentBlockValueModel";
import MultiLanguages from "@admin/components/MultiLanguage";
import JoditEditor from "@admin/components/JoditEditor";

type Props = BlockProps<TextBlockValueModel>;

const defaultValue: TextBlockValueModel = {
    text: {},
};

export default function TextBlock({ index, value = structuredClone(defaultValue) }: Props) {
    return (
        <MultiLanguages
            languageElement={(language) => (
                <div className="mb-5">
                    <JoditEditor
                        name={`blocks[${index}][value][text][${language}]`}
                        initHtml={value.text[language] || ``}
                    />
                </div>
            )}
        />
    );
}
